import { NewsletterModel } from 'models/NewsletterModel';
import { combineReducers, createReducer, ReducerOptionalMapObject } from 'store/createReducer';
import { Action } from 'redux';
import { SERVER_RESPONSE_ERROR } from 'components/ErrorModal/actions';
import {
  NEWSLETTER_SUBSCRIBE_SUCCESS,
  NEWSLETTER_SHOW_EMAIL_INVALID,
  NEWSLETTER_CLOSE_MODAL,
  NEWSLETTER_SUBSCRIBE,
  NEWSLETTER_SET_EMAIL,
  CCC_MARKETING_CONSENT
} from './actions';

interface NewsletterState extends NewsletterModel {
  subscribeSuccess: boolean;
  showSpinner: boolean;
  emailValid: boolean;
}

interface SetEmailAction extends Action {
  payload: { email: string; valid: boolean };
}

interface SetCookieConsentAction extends Action {
  payload: { accepted: boolean };
}

export const initialState: NewsletterState = {
  newsletterDisclaimer: {},
  newsletterUSPs: [],
  showModal: false,
  subscribeSuccess: false,
  showSpinner: false,
  email: '',
  emailValid: false,
  marketingCookieConsent: false,
  showPopUp: false,
  showDiscount: false
};

const showModal = createReducer(initialState.showModal, {
  [NEWSLETTER_SUBSCRIBE_SUCCESS]: () => true,
  [NEWSLETTER_SHOW_EMAIL_INVALID]: () => true,
  [NEWSLETTER_CLOSE_MODAL]: () => false
});

const subscribeSuccess = createReducer(initialState.subscribeSuccess, {
  [NEWSLETTER_SUBSCRIBE_SUCCESS]: () => true,
  [SERVER_RESPONSE_ERROR]: () => false,
  [NEWSLETTER_CLOSE_MODAL]: () => false
});

const showSpinner = createReducer(initialState.showSpinner, {
  [NEWSLETTER_SUBSCRIBE]: () => true,
  [NEWSLETTER_SUBSCRIBE_SUCCESS]: () => false,
  [SERVER_RESPONSE_ERROR]: () => false,
  [NEWSLETTER_CLOSE_MODAL]: () => false
});

const email = createReducer(initialState.email, {
  [NEWSLETTER_SET_EMAIL]: (_, action: SetEmailAction) => action.payload.email
});

const emailValid = createReducer(initialState.emailValid, {
  [NEWSLETTER_SET_EMAIL]: (_, action: SetEmailAction) => action.payload.valid
});

const marketingCookieConsent = createReducer(initialState.marketingCookieConsent, {
  [CCC_MARKETING_CONSENT]: (_, action: SetCookieConsentAction) => {
    return action.payload.accepted;
  }
});

export default combineReducers<NewsletterState, ReducerOptionalMapObject>({
  ...initialState,
  showModal,
  subscribeSuccess,
  email,
  showSpinner,
  emailValid,
  marketingCookieConsent
});
